module.exports = __webpack_public_path__ + "img/3-4-2.a307ea03.png";